import { render, staticRenderFns } from "./ProveedoresIndex.vue?vue&type=template&id=df96dee6&scoped=true&"
import script from "./ProveedoresIndex.vue?vue&type=script&lang=js&"
export * from "./ProveedoresIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProveedoresIndex.vue?vue&type=style&index=0&id=df96dee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df96dee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFadeTransition,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle,VSubheader,VTextField})
